export const NAMESPACE = 'ib-podcast';

export const STORE_NAME = 'ib/podcast';
export const FILTER_NAMESPACE = STORE_NAME;

export const I18N_DOMAIN = NAMESPACE;
